/*
  Example:
    import { formatTimespanTwo } from '@/utilities/Date/formatTimespanTwo'

    const timespanString = formatTimespanTwo(startTime, endTime)

    startTime and endTime may be moment objects or parseable date/time strings
*/
import moment from 'moment'

export const formatTimespanTwo = (startTime, endTime) => {
  let time1 = startTime
  let time2 = endTime

  if (typeof time1 === 'string') {
    time1 = moment(time1)
    if (!time1.isValid()) return 'Invalid start time'
  }

  if (typeof time2 === 'string') {
    time2 = moment(time2)
    if (!time2.isValid()) return 'Invalid end time'
  }

  if (time1.isSame(time2, 'day')) {
    // Same-day format
    return time1.format('LL hh:mm A') + ' to ' + time2.format('hh:mm A')
  } else {
    return time1.format('LL hh:mm A') + ' to ' + time2.format('LL hh:mm A')
  }
}
